import { observer } from "mobx-react-lite";
import ShopHistoryTable from "../../pages/shop/components/ShopHistoryTable";
import { useCallback, useEffect, useState } from "react";
import { ActionsSection, ButtonsSection } from "e.sic-platform.webclient/src/components/data-components/sections/DataSections";
import AddNewButton from "e.sic-platform.webclient/src/components/buttons/add-new-button/AddNewButton";
import LoadButton from "../buttons/app-action-buttons/LoadButton";
import RedoButton from "../buttons/app-action-buttons/RedoButton";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { Dialog } from "e.sic-platform.webclient/src/components/dialog/Dialog";
import CopyUrlButton from "../buttons/copy-url-button/CopyUrlButton";
import { AppStorage } from "e.sic-platform.webclient/src/services/app/AppStorage";
import WarningBeforeAction from "e.sic-platform.webclient/src/components/data-components/WarningBeforeAction";
import OrderOverview from "./OrderOverview";
import { creditBalanceStorage } from "e.sic-platform.webclient/src/services/shop/CreditBalanceStorage";
import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { ActivityTypes } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";

export interface IHotbarProps {
    appStorage: AppStorage
    actionBar?: any;
}

export default observer(function SmartAppHotbar(props: IHotbarProps) {
    const {appStorage} = {...props};
    const [showLoading, setShowLoading] = useState(false);
    const [showRedo, setShowRedo] = useState(false);
    const [redoEnabled, setRedoEnabled] = useState(false);

    const toggleRedo = useCallback(() => {
        setShowRedo(!showRedo);
    }, [showRedo])

    const toggleLoading = useCallback(async () => {
        await appStorage.historyStorage.load();
        setShowLoading(!showLoading)
    }, [showLoading, appStorage.historyStorage]);

    useEffect(() => {
        creditBalanceStorage.validateRemainingBalance(appStorage.activityType).then((result) => {
            setRedoEnabled(!result);
        });
    }, [appStorage.activityType]);

    useEffect(() => {
        setShowLoading(false)
    }, [appStorage.fileGuid])
    
    return (
        <>
            <Dialog titleKey="general.apps.load.title" isVisible={showLoading} onHide={toggleLoading} maxWidth="lg">
                <ShopHistoryTable rowClickPath={appStorage.historyStorage.clickPath} shopHistoryStorage={appStorage.historyStorage} showDeleteButton={false} noSelection={true} />
            </Dialog>
            <WarningBeforeAction 
                titleKey="general.redo.confirm.title" 
                isVisible={showRedo} 
                toggleModal={toggleRedo}
                buttonOk={{
                    textKey: "general.redo",
                    action: () => {
                        appStorage.redo();
                        toggleRedo();
                    },
                    disabled: !redoEnabled && appStorage.redoSelection.length === 0
                }}
            >
                <div>{translationService.translate("general.redo.confirm.description")}</div>
                <Stack pr={8}>
                    {appStorage.redoableServices.map((service: {label: string, service: ActivityTypes}) => (
                        <FormControlLabel 
                            control={<Checkbox checked={appStorage.redoSelection.includes(service.service)} onChange={() => appStorage.toggleRedoSelection(service.service)}/>} 
                            label={translationService.translate(service.label)} 
                        />
                    ))}
                    <OrderOverview price={appStorage.redoPrice} />
                </Stack>
            </WarningBeforeAction>
            <div style={{overflow: "scroll", scrollbarWidth: "none"}}>
                <ActionsSection isSticky={false}>
                    <ButtonsSection>
                        <AddNewButton onClick={appStorage.new} buttonText={translationService.translate("general.new")} />
                        <LoadButton onClick={toggleLoading} />
                        <RedoButton onClick={toggleRedo} disabled={appStorage.step < 2}/>
                        {props.actionBar}
                    </ButtonsSection>
                    {appStorage.fileId && (
                        <ButtonsSection>
                            <CopyUrlButton id={appStorage.fileId}/>
                        </ButtonsSection>
                    )}
                </ActionsSection>
            </div>
        </>
    )
})